var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramShare64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Share64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictpgram",
    transform: "translate(11.000000, 11.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5,6 L6.5,21",
    id: "Line-Top",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,21.5 L35.5,36",
    id: "Line-Bottom",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Middle",
    fill: "#FFFFFF",
    cx: 6,
    cy: 21.1843343,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Top",
    fill: "#FFFFFF",
    cx: 36,
    cy: 6.18433431,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Bottom",
    fill: "#FFCC00",
    cx: 36,
    cy: 36.1843343,
    r: 6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramShare64);
export default __webpack_public_path__ + "static/media/pictogramShare64.8b465d7b8f8e7d089a5a6afa885bece8.svg";
export { ForwardRef as ReactComponent };